function getIsVACJourneyEnabled(configuration) {
  return configuration.app?.solJourney?.vacJourney?.enabled;
}

module.exports = { getIsVACJourneyEnabled };
